// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__twCaJ","content":"GlobalSearch_content__35_uh"};